/**
 * Empty-state placeholder shown when the assistant transcript has no
 * messages yet and the connection is healthy. Pane-specific: lives next
 * to `AssistantPaneView` rather than under `components/assistant/`
 * because it's not reused elsewhere.
 */
const AssistantPaneEmptyState = () => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    <div className="bg-brand-secondary mb-4 flex size-16 items-center justify-center rounded-full">
      <AssistantIcon className="text-brand-solid size-8" />
    </div>
    <div className="text-primary mb-2 text-lg font-semibold">Mantle Assistant</div>
    <div className="text-secondary mb-6 max-w-sm text-sm">
      Ask questions about your accounts, transactions, spending patterns, and recurring bills.
    </div>
    <div className="text-tertiary space-y-2 text-sm">
      <div>Try asking:</div>
      <ul className="text-secondary space-y-1">
        <li>"What is my current balance on my Chase credit card?"</li>
        <li>"How much did I spend last week?"</li>
        <li>"What are my biggest spending categories this month?"</li>
        <li>"What subscriptions do I have?"</li>
      </ul>
    </div>
  </div>
);

const AssistantIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

export default AssistantPaneEmptyState;
